import React, { useEffect, useState } from 'react';

import { API_URL } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import { CURRENT_DATE, CURRENT_TIME } from '../../constants';

const ActivityReport = ({ sections, link }) => {
  const formatLabel = (str) =>
    str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase());

  // Get the jsonData from localStorage
  const storedData = localStorage.getItem('printData');
  const linkData = localStorage.getItem('linkData');

  //console.log('localstorage:', storedData)

  const parsedData = JSON.parse(storedData); // Parse the JSON string back into an object
  const linkParsedData = JSON.parse(linkData); // Parse the JSON string back into an object

  if (!sections && !link) {
    sections = parsedData;
    link = linkParsedData;
  }

  const renderFields = (fields) => (
    <div style={{ marginBottom: '20px' }}>
      <table className="table table-bordered">
        <tbody>
          {Object.entries(fields).map(([key, value]) => (
            <tr key={key}>
              {' '}
              <th>{formatLabel(key)}:</th> <td>{value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const renderTable = (rows) => {
    if (rows.length === 0) return null;

    // Get all column keys from the first row
    let columnKeys = Object.keys(rows[0]);

    // If "has_footer" exists, remove it from the columns
    const hasFooterKey = columnKeys.includes('has_footer');
    if (hasFooterKey) {
      columnKeys = columnKeys.filter((key) => key !== 'has_footer');
    }

    return (
      <table className="table table-bordered">
        <thead>
          <tr>
            {columnKeys.map((key) => (
              <th key={key}>{formatLabel(key)}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const isLastRow = index === rows.length - 1;
            return (
              <tr
                key={index}
                style={hasFooterKey && isLastRow ? { fontWeight: 'bold' } : {}}
              >
                {columnKeys.map((key) => (
                  <td key={key}>{row[key]}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  if (!sections.length) return <p>Loading...</p>;
  console.log('sections:', sections);
  const styles = {
    printPage: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid black',
    },
    cell: {
      border: '1px solid black',
      textAlign: 'left',
    },
    header: {
      textAlign: 'center',
      marginBottom: '20px',
    },
    logo: {
      width: '100%',
      height: '150px',
    },
  };

  const token = getToken();
  const companyLogo = decodeToken(token, 'logo');
  const companyBanner = decodeToken(token, 'banner');

  const companyName = decodeToken(token, 'companyName');
  console.log('link:', link);
  return (
    <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
      <header style={styles.header}>
        <img
          src={`${API_URL}/${companyBanner}`}
          alt="Company Banner"
          style={styles.logo}
        />
      </header>
      <h2 style={{ textAlign: 'center' }}>{link?.page_title}</h2>
      <div
        style={{ textAlign: 'right', marginTop: '5px', marginBottom: '5px' }}
      >
        Printed:{' '}
        <strong>
          {CURRENT_DATE} {CURRENT_TIME}
        </strong>
      </div>
      <p>{link?.description}</p>

      <div className="row">
        {sections.map((section, index) => (
          <>
            <div key={index} className={`col-${section.grid}`}>
              <h4>{section.title}</h4>
              {section.fields && renderFields(section.fields)}
              {section.table && renderTable(section.table)}
            </div>
            {section.space !== '' && (
              <div className={`col-${section.space}`}></div>
            )}
          </>
        ))}
      </div>
      {/* <footer style={{ marginTop: '40px', fontSize: '14px' }}>
        <strong>Address:</strong> dhuusamreeb-dayax village &nbsp; | &nbsp;
        <strong>Email:</strong> info@mopedic.gm.so
      </footer> */}
    </div>
  );
};

export default ActivityReport;
